import { render, staticRenderFns } from "./CdbCustomerCoupon.vue?vue&type=template&id=16edcef0&scoped=true&"
import script from "./CdbCustomerCoupon.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerCoupon.vue?vue&type=style&index=0&id=16edcef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edcef0",
  null
  
)

export default component.exports